import React from 'react'
import moment from 'moment'
import PointIcon from 'material-ui/svg-icons/av/fiber-manual-record'
import { ListItem } from 'material-ui/List'
import Mail from 'material-ui/svg-icons/content/mail'
import { themeColors } from '../styles/theme'

const styles = {
  unreadPoint: {
    height: 15,
    width: 15,
  },
  date: {
    color: themeColors.energized,
    fontSize: 12,
  },
  primaryText: {
    fontSize: 13,
  },
}

export default ({ message, type }) => {
  const unreadMessage = type === 'inbox' && !message.read
  return (
    <ListItem
      leftIcon={<Mail color="#00b4bc" />}
      rightIcon={
        unreadMessage
          ? <PointIcon
              color={themeColors.positive}
              style={styles.unreadPoint}
            />
          : undefined
      }
      primaryText={
        type === 'inbox'
          ? <span style={styles.primaryText}>
              Da:
              {' '}
              <span style={{ fontWeight: 'bold' }}>
                {message.mittente.username}
              </span>
            </span>
          : <span style={styles.primaryText}>
              A:
              {' '}
              <span style={{ fontWeight: 'bold' }}>
                {message.destinatario.username}
              </span>
            </span>
      }
      secondaryText={
        <div>
          <div style={styles.date}>
            {moment(message.created_at).format('DD/MM/YYYY')}
          </div>
          <div>{message.testo}</div>
        </div>
      }
      secondaryTextLines={2}
    />
  )
}



// WEBPACK FOOTER //
// ./src/common/MessageListItem.js